(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["start-here-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    if (!window.customElements || customElements.get('start-here-quiz')) return;

    /* =====================================================================
       CATALOG MAP — the only place product handles and quiz copy live.
       Handles were checked against the live store on 2026-10-12.
       ===================================================================== */

    var LINEUP = {
      lions_mane: {
        name: "Lion's Mane",
        goal: 'Focus and mental clarity',
        supports: "Lion's Mane supports cognitive clarity and focus.",
        botanical: 'Gotu Kola',
        classic: { alcohol_free: 'lions-mane-tincture-glycerine-base', alcohol: 'lions-mane-tincture-1' },
        gnar: 'gnar-tar-lions-mane'
      },
      cordyceps: {
        name: 'Cordyceps',
        goal: 'Natural energy and endurance',
        supports: 'Cordyceps supports natural energy and endurance, without the crash or jitters of stimulants.',
        botanical: 'Eleuthero',
        classic: { alcohol_free: 'cordyceps-tincture-glycerine-base', alcohol: 'cordyceps-militaris-tincture-1' },
        gnar: 'gnar-tar-cordyceps'
      },
      reishi: {
        name: 'Reishi',
        goal: 'Unwinding and restful sleep',
        supports: "Reishi supports your body's response to stress and promotes restful sleep.",
        botanical: 'Elderberry',
        classic: { alcohol_free: 'reishi-tincture-glycerine-base', alcohol: 'reishi-tincture' },
        gnar: 'gnar-tar-reishi'
      },
      turkey_tail: {
        name: 'Turkey Tail',
        goal: 'Immune and digestive support',
        supports: 'Turkey Tail supports immune function and digestive health.',
        botanical: 'Echinacea',
        classic: { alcohol_free: 'turkey-tail-tincture-glycerine-base-1', alcohol: 'turkey-tail-tincture-1' },
        gnar: null,
        onlyNote: 'Turkey Tail comes as a classic tincture.'
      },
      chaga: {
        name: 'Chaga',
        goal: 'A steady daily tonic',
        supports: 'Chaga has long been used as an earthy daily tonic mushroom: a simple, steady ritual.',
        botanical: null,
        classic: null,
        gnar: 'gnar-tar-chaga',
        onlyNote: 'Chaga comes as a Gnar Tar concentrate.'
      },
      set: {
        isSet: true,
        name: 'The sets',
        goal: "All of it, or I'm not sure yet",
        supports: 'Four mushrooms in one daily toolkit.',
        botanical: null,
        classic: { alcohol_free: 'mycosymbiotic-set-glycerine-base', alcohol: 'mycosymbiotic-4-set' },
        gnar: 'gnar-tar-full-spectrum-bundle',
        classicContents: "Lion's Mane, Reishi, Cordyceps and Turkey Tail",
        gnarContents: "Lion's Mane, Cordyceps, Chaga and Reishi"
      }
    };

    var ORDER = ['lions_mane', 'cordyceps', 'reishi', 'turkey_tail', 'chaga', 'set'];

    var POWDER_HANDLE = 'probiotic-lions-mane-extract';

    var FORMATS = {
      classic: {
        name: 'Classic tincture',
        blurb: 'One functional mushroom paired with a complementary organic botanical. Three sizes, alcohol-free or traditional alcohol extract.'
      },
      gnar: {
        name: 'Gnar Tar concentrate',
        blurb: 'Our alcohol-free concentrate line, 20:1 or higher. The strongest format we make.'
      }
    };

    var BASES = {
      alcohol_free: 'alcohol-free',
      alcohol: 'traditional alcohol extract',
      no_preference: 'alcohol-free'
    };

    var QUESTIONS = {
      goal: {
        title: 'What are you looking for?',
        help: 'Pick the one that matters most right now.',
        options: ORDER.map(function (key) {
          return { value: key, label: LINEUP[key].goal, hint: LINEUP[key].isSet ? 'A set of four' : LINEUP[key].name };
        })
      },
      strength: {
        title: 'How strong do you want it?',
        help: 'We make two formats. Pick the one that sounds like you.',
        options: [
          { value: 'classic', label: "I'm easing in", hint: 'Classic tincture: a mushroom plus a complementary organic botanical, in three sizes.' },
          { value: 'gnar', label: 'Give me the strongest', hint: 'Gnar Tar: our alcohol-free concentrate line, 20:1 or higher.' }
        ]
      },
      base: {
        title: 'Alcohol-free or traditional?',
        help: 'Our classic tinctures come in two bases.',
        options: [
          { value: 'alcohol_free', label: 'Alcohol-free', hint: 'Organic flaxseed glycerin base.' },
          { value: 'alcohol', label: 'Traditional alcohol extract', hint: '' },
          { value: 'no_preference', label: 'No preference', hint: "We'll show you the alcohol-free version." }
        ]
      }
    };

    /* =====================================================================
       Quiz logic — pure functions, no DOM.
       ===================================================================== */

    function formatFor(goal, strength) {
      var m = LINEUP[goal];
      if (!m) return null;
      if (!m.gnar) return 'classic';
      if (!m.classic) return 'gnar';
      if (strength === 'classic' || strength === 'gnar') return strength;
      return null;
    }

    function nextStep(answers) {
      if (!answers.goal || !LINEUP[answers.goal]) return 'goal';
      var format = formatFor(answers.goal, answers.strength);
      if (!format) return 'strength';
      if (format === 'classic' && !BASES[answers.base]) return 'base';
      return 'result';
    }

    function resolve(answers) {
      if (nextStep(answers) !== 'result') return null;
      var m = LINEUP[answers.goal];
      var format = formatFor(answers.goal, answers.strength);
      var base = null;
      if (format === 'classic') base = answers.base === 'alcohol' ? 'alcohol' : 'alcohol_free';
      var handle = format === 'classic' ? m.classic[base] : m.gnar;
      var setHandle = null;
      if (!m.isSet) setHandle = format === 'classic' ? LINEUP.set.classic[base] : LINEUP.set.gnar;
      return {
        goal: answers.goal,
        format: format,
        base: base,
        basePreference: format === 'classic' ? answers.base : null,
        handle: handle,
        setHandle: setHandle
      };
    }

    function whyLines(result) {
      var m = LINEUP[result.goal];
      var lines = [];
      if (m.isSet) {
        if (result.format === 'classic') {
          lines.push('The Synergistic 4 Set gives you ' + m.classicContents + ' in one daily toolkit, as ' + (result.base === 'alcohol' ? 'traditional alcohol extracts' : 'alcohol-free tinctures') + '.');
        } else {
          lines.push('The Gnar Tar 4-Set brings ' + m.gnarContents + ' together in our alcohol-free concentrate line, the strongest format we make.');
        }
        return lines;
      }
      lines.push(m.supports);
      if (result.format === 'classic') {
        lines.push('The classic tincture pairs it with organic ' + m.botanical + (result.base === 'alcohol' ? ', as a traditional alcohol extract.' : ', in an alcohol-free glycerin base.'));
      } else {
        lines.push('Gnar Tar is our alcohol-free concentrate line, the strongest format we make.');
      }
      if (m.onlyNote) lines.push(m.onlyNote);
      return lines;
    }

    /* Monthly subscription for a variant, or null. Products carry several Seal plans
       (monthly, every 2 months); the quiz offers the monthly one and leaves the rest
       to the product page. */
    function isMonthlyPlan(plan) {
      var values = (plan.options || []).map(function (o) {
        return String((o && o.value) || '').toLowerCase().trim();
      }).filter(Boolean);
      if (values.some(function (v) { return /^((1|one|every)\s+)?month$/.test(v); })) return true;
      if (values.length) return false;
      var name = String(plan.name || '').toLowerCase();
      return /\bmonthly\b/.test(name) && !/\bbi-?monthly\b/.test(name);
    }

    function monthlyPlan(product, variant) {
      var plans = {};
      (product.selling_plan_groups || []).forEach(function (group) {
        (group.selling_plans || []).forEach(function (plan) { plans[plan.id] = plan; });
      });
      var match = null;
      (variant.selling_plan_allocations || []).forEach(function (alloc) {
        var plan = plans[alloc.selling_plan_id];
        if (!match && plan && isMonthlyPlan(plan)) match = { plan: plan, alloc: alloc };
      });
      if (!match) return null;
      var saving = variant.price > 0 ? Math.round((1 - match.alloc.price / variant.price) * 100) : 0;
      return { planId: match.plan.id, price: match.alloc.price, saving: saving };
    }

    function sortedVariants(product) {
      return (product.variants || []).slice().sort(function (a, b) { return a.price - b.price; });
    }

    function defaultVariant(product) {
      var variants = sortedVariants(product);
      var oneOz = variants.filter(function (v) { return /^1\s*oz\b/i.test(v.title) && v.available; })[0];
      return oneOz || variants.filter(function (v) { return v.available; })[0] || variants[0] || null;
    }

    function sizeParts(title) {
      var m = String(title).match(/^(.*?)\s*\((.*?)\)\s*(.*)$/);
      var label = (m ? m[1] : String(title)).replace(/(\d)oz/i, '$1 oz').trim();
      var detail = m ? [m[2], m[3]].filter(Boolean).join(' · ') : '';
      return { label: label, detail: detail };
    }

    /* =====================================================================
       Small helpers
       ===================================================================== */

    function el(tag, attrs, children) {
      var node = document.createElement(tag);
      Object.keys(attrs || {}).forEach(function (key) {
        var value = attrs[key];
        if (value === null || value === undefined || value === false) return;
        if (key === 'class') node.className = value;
        else if (key === 'text') node.textContent = value;
        else if (key.slice(0, 2) === 'on') node.addEventListener(key.slice(2), value);
        else node.setAttribute(key, value === true ? '' : value);
      });
      (children || []).forEach(function (child) {
        if (child === null || child === undefined || child === false) return;
        node.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
      });
      return node;
    }

    function imageUrl(src, width) {
      if (!src) return '';
      var url = src.indexOf('//') === 0 ? 'https:' + src : src;
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    function publish(name, payload) {
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(name, payload);
        }
      } catch (e) { /* analytics must never break the quiz */ }
    }

    function klaviyoTrack(name, payload) {
      try {
        var k = window.klaviyo || window._learnq;
        if (k && typeof k.push === 'function') k.push(['track', name, payload]);
      } catch (e) { /* same */ }
    }

    /* =====================================================================
       <start-here-quiz>
       ===================================================================== */

    class StartHereQuiz extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        var configNode = this.querySelector('[data-shq-config]');
        this.config = {};
        try { this.config = JSON.parse(configNode.textContent); } catch (e) { /* defaults below */ }
        this.config.rootUrl = this.config.rootUrl || '/';
        if (this.config.rootUrl.slice(-1) !== '/') this.config.rootUrl += '/';

        this.stage = this.querySelector('[data-shq-stage]');
        this.status = this.querySelector('[data-shq-status]');
        this.answers = {};
        this.trail = [];
        this.products = new Map();
        this.renderToken = 0;

        try {
          this.money = new Intl.NumberFormat(this.config.locale || undefined, {
            style: 'currency',
            currency: this.config.currency || 'USD'
          });
        } catch (e) {
          this.money = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' });
        }

        this.renderLineup();
        this.render(false);
      }

      formatMoney(cents) {
        return this.money.format(cents / 100);
      }

      productUrl(handle) {
        return this.config.rootUrl + 'products/' + handle;
      }

      fetchProduct(handle) {
        if (!this.products.has(handle)) {
          var request = fetch(this.productUrl(handle) + '.js', { headers: { Accept: 'application/json' } })
            .then(function (response) {
              if (!response.ok) throw new Error('Product not available: ' + handle);
              return response.json();
            });
          this.products.set(handle, request);
          request.catch(function () { /* handled by callers */ });
        }
        return this.products.get(handle);
      }

      announce(message) {
        if (this.status) this.status.textContent = message;
      }

      render(moveFocus) {
        this.renderToken += 1;
        var step = nextStep(this.answers);
        if (step === 'result') this.renderResult(moveFocus);
        else this.renderQuestion(step, moveFocus);
      }

      answer(step, value) {
        this.answers[step] = value;
        this.trail.push(step);
        this.render(true);
      }

      back() {
        var step = this.trail.pop();
        if (step) delete this.answers[step];
        this.render(true);
      }

      restart() {
        this.answers = {};
        this.trail = [];
        this.render(true);
      }

      topbar(label) {
        var self = this;
        return el('div', { class: 'shq__topbar' }, [
          el('span', { text: label }),
          this.trail.length
            ? el('button', { type: 'button', class: 'shq__linkbtn', text: 'Back', onclick: function () { self.back(); } })
            : null
        ]);
      }

      renderQuestion(step, moveFocus) {
        var self = this;
        var question = QUESTIONS[step];
        var heading = el('h2', { class: 'shq__question h2', tabindex: '-1', text: question.title });

        var options = question.options.map(function (option) {
          return el('li', {}, [
            el('button', {
              type: 'button',
              class: 'shq__option',
              'data-shq-value': option.value,
              onclick: function () { self.answer(step, option.value); }
            }, [
              el('span', { class: 'shq__option-text' }, [
                el('span', { class: 'shq__option-label', text: option.label }),
                option.hint ? el('span', { class: 'shq__option-hint', text: option.hint }) : null
              ]),
              el('span', { class: 'shq__option-arrow', 'aria-hidden': 'true', text: '→' })
            ])
          ]);
        });

        this.stage.classList.remove('shq__stage--wide');
        this.stage.replaceChildren(
          this.topbar('Question ' + (this.trail.length + 1)),
          heading,
          el('p', { class: 'shq__help', text: question.help }),
          el('ul', { class: 'shq__options', role: 'list' }, options)
        );
        if (moveFocus) heading.focus();
      }

      renderResult(moveFocus) {
        var self = this;
        var token = this.renderToken;
        var result = resolve(this.answers);

        this.stage.classList.add('shq__stage--wide');
        this.stage.replaceChildren(el('p', { class: 'shq__loading', text: 'Finding your match…' }));

        this.fetchProduct(result.handle).then(function (product) {
          if (token !== self.renderToken) return;
          self.showResult(result, product, moveFocus);
        }).catch(function () {
          if (token !== self.renderToken) return;
          self.showFallback(result);
        });
      }

      showFallback(result) {
        var self = this;
        this.stage.replaceChildren(
          this.topbar('Your match'),
          el('div', { class: 'shq__fallback' }, [
            el('p', { text: "We couldn't load that product just now." }),
            el('p', {}, [
              el('a', { class: 'shq__link', href: this.productUrl(result.handle), text: 'Open the product page' }),
              ' or ',
              el('a', { class: 'shq__link', href: this.config.allProductsUrl || '/collections/all', text: 'browse everything' }),
              '.'
            ]),
            el('p', {}, [
              el('button', { type: 'button', class: 'shq__linkbtn', text: 'Start over', onclick: function () { self.restart(); } })
            ])
          ])
        );
      }

      showResult(result, product, moveFocus) {
        var self = this;
        var meta = LINEUP[result.goal];
        var url = product.url || this.productUrl(result.handle);
        var variants = sortedVariants(product);
        var state = {
          variant: defaultVariant(product),
          mode: 'once'
        };
        if (this.config.preselectSubscription && state.variant && monthlyPlan(product, state.variant)) state.mode = 'sub';

        var title = el('h2', { class: 'shq__result-title h1', tabindex: '-1' }, [
          el('a', { href: url, text: product.title })
        ]);

        var why = el('div', { class: 'shq__why' }, whyLines(result).map(function (line) {
          return el('p', { text: line });
        }));

        var setNote = meta.isSet
          ? el('p', {
              class: 'shq__note',
              text: result.format === 'classic'
                ? 'Good to know: this set includes Turkey Tail. The Gnar Tar 4-Set swaps it for Chaga.'
                : 'Good to know: this set includes Chaga. The classic Synergistic 4 Set has Turkey Tail in its place.'
            })
          : null;

        /* ----- size ----- */
        var sizeDetail = el('p', { class: 'shq__pill-detail' });
        var sizeGroup = null;
        var groupName = 'shq-size-' + this.id;
        if (variants.length > 1) {
          sizeGroup = el('fieldset', { class: 'shq__group' }, [
            el('legend', { class: 'shq__legend', text: 'Size' }),
            el('div', { class: 'shq__pills' }, variants.map(function (variant) {
              var parts = sizeParts(variant.title);
              var input = el('input', {
                type: 'radio',
                name: groupName,
                value: String(variant.id),
                disabled: !variant.available,
                onchange: function () { state.variant = variant; update(); }
              });
              if (state.variant && variant.id === state.variant.id) input.checked = true;
              return el('label', { class: 'shq__pill' }, [
                input,
                el('span', { text: parts.label })
              ]);
            })),
            sizeDetail
          ]);
        }

        /* ----- one-time vs subscription ----- */
        var oncePrice = el('span', { class: 'shq__choice-price' });
        var subPrice = el('span', { class: 'shq__choice-price' });
        var subSaving = el('span', { class: 'shq__choice-sub' });
        var modeName = 'shq-mode-' + this.id;
        var onceInput = el('input', { type: 'radio', name: modeName, value: 'once', onchange: function () { state.mode = 'once'; update(); } });
        var subInput = el('input', { type: 'radio', name: modeName, value: 'sub', onchange: function () { state.mode = 'sub'; update(); } });
        var subRow = el('label', { class: 'shq__choice' }, [
          subInput,
          el('span', { class: 'shq__choice-body' }, [
            el('span', { class: 'shq__choice-label' }, [
              el('span', { text: 'Subscribe monthly' }),
              subSaving
            ]),
            subPrice
          ])
        ]);
        var modeGroup = el('fieldset', { class: 'shq__group' }, [
          el('legend', { class: 'shq__legend', text: 'How would you like it?' }),
          el('div', { class: 'shq__choices' }, [
            el('label', { class: 'shq__choice' }, [
              onceInput,
              el('span', { class: 'shq__choice-body' }, [
                el('span', { class: 'shq__choice-label' }, [el('span', { text: 'One-time purchase' })]),
                oncePrice
              ])
            ]),
            subRow
          ])
        ]);

        /* ----- actions ----- */
        var error = el('p', { class: 'shq__error', role: 'alert', hidden: true });
        var addButton = el('button', {
          type: 'button',
          class: 'button button--primary',
          'data-shq-add': true,
          onclick: function () { self.addToCart(result, product, state, addButton, error); }
        });

        function update() {
          var variant = state.variant;
          if (!variant) return;
          var plan = monthlyPlan(product, variant);
          if (!plan && state.mode === 'sub') state.mode = 'once';

          sizeDetail.textContent = sizeParts(variant.title).detail;
          oncePrice.textContent = self.formatMoney(variant.price);
          subRow.hidden = !plan;
          if (plan) {
            subPrice.textContent = self.formatMoney(plan.price);
            subSaving.textContent = plan.saving > 0 ? 'Save ' + plan.saving + '% on every order' : '';
          }
          onceInput.checked = state.mode === 'once';
          subInput.checked = state.mode === 'sub';

          var price = state.mode === 'sub' && plan ? plan.price : variant.price;
          if (variant.available) {
            addButton.disabled = false;
            addButton.textContent = (state.mode === 'sub' ? 'Subscribe' : 'Add to cart') + ' — ' + self.formatMoney(price);
          } else {
            addButton.disabled = true;
            addButton.textContent = 'Sold out';
          }
        }

        /* ----- extras: the matching set, the powder ----- */
        var extras = el('div', { class: 'shq__extras', hidden: true });

        if (result.setHandle) {
          this.fetchProduct(result.setHandle).then(function (set) {
            if (!set.available) return;
            extras.hidden = false;
            extras.insertBefore(el('p', {}, [
              'Want more than one mushroom? ',
              el('a', { class: 'shq__link', href: set.url || self.productUrl(result.setHandle), text: 'See the ' + set.title }),
              '.'
            ]), extras.firstChild);
          }).catch(function () { /* no nudge if the set is unavailable */ });
        }

        if (this.config.showPowder && result.goal === 'lions_mane') {
          this.fetchProduct(POWDER_HANDLE).then(function (powder) {
            if (!powder.available) return;
            extras.hidden = false;
            extras.appendChild(el('p', {}, [
              'Prefer a powder? ',
              el('a', { class: 'shq__link', href: powder.url || self.productUrl(POWDER_HANDLE), text: 'See the ' + powder.title }),
              '.'
            ]));
          }).catch(function () { /* optional */ });
        }

        var image = null;
        if (product.featured_image) {
          image = el('div', { class: 'shq__media' }, [
            el('img', {
              src: imageUrl(product.featured_image, 900),
              alt: product.title,
              width: '900',
              height: '900',
              onerror: function () { image.hidden = true; }
            })
          ]);
        }

        var column = el('div', { class: 'shq__result-body' }, [
          title,
          why,
          setNote,
          sizeGroup,
          modeGroup,
          el('div', { class: 'shq__actions' }, [
            addButton,
            el('a', { class: 'shq__link', href: url, text: 'View full details' })
          ]),
          error,
          extras,
          this.emailForm(result, product)
        ]);

        update();

        this.stage.replaceChildren(
          el('div', { class: 'shq__topbar' }, [
            el('span', { text: 'Your match' }),
            el('button', { type: 'button', class: 'shq__linkbtn', text: 'Start over', onclick: function () { self.restart(); } })
          ]),
          el('div', { class: 'shq__result' }, [image, column])
        );

        this.announce('Your match: ' + product.title);
        if (moveFocus) title.focus();

        var payload = this.payload(result, product);
        publish('start_here_quiz_completed', payload);
        klaviyoTrack('Completed Start Here Quiz', payload);
      }

      payload(result, product) {
        return {
          quiz_goal: LINEUP[result.goal].goal,
          quiz_mushroom: LINEUP[result.goal].isSet ? 'Set' : LINEUP[result.goal].name,
          quiz_format: FORMATS[result.format].name,
          quiz_base: result.base ? BASES[result.base] : '',
          quiz_recommended_product: product.title,
          quiz_recommended_handle: result.handle
        };
      }

      addToCart(result, product, state, button, error) {
        var self = this;
        var variant = state.variant;
        if (!variant) return;
        var plan = state.mode === 'sub' ? monthlyPlan(product, variant) : null;
        var item = { id: variant.id, quantity: 1 };
        if (plan) item.selling_plan = plan.planId;

        var label = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding…';
        error.hidden = true;

        fetch(this.config.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || '');
            return data;
          });
        }).then(function () {
          var payload = self.payload(result, product);
          payload.quiz_purchase_type = plan ? 'subscription' : 'one-time';
          publish('start_here_quiz_add_to_cart', payload);
          window.location.assign(self.config.cartUrl || '/cart');
        }).catch(function (err) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = label;
          error.textContent = (err && err.message) || "We couldn't add that to your cart. Please try from the product page.";
          error.hidden = false;
        });
      }

      emailForm(result, product) {
        var self = this;
        var config = this.config;
        if (!config.emailEnabled || !config.klaviyoKey || !config.klaviyoListId) return null;

        var inputId = 'shq-email-' + this.id;
        var input = el('input', {
          id: inputId,
          class: 'shq__email-input',
          type: 'email',
          name: 'email',
          autocomplete: 'email',
          placeholder: 'you@example.com',
          required: true
        });
        var submit = el('button', { type: 'submit', class: 'shq__email-submit', text: 'Sign me up' });
        var message = el('p', { class: 'shq__email-message', role: 'status', hidden: true });
        var row = el('div', { class: 'shq__email-row' }, [input, submit]);

        var form = el('form', {
          class: 'shq__email',
          onsubmit: function (event) {
            event.preventDefault();
            var email = input.value.trim();
            if (!email || !input.checkValidity()) {
              input.reportValidity();
              return;
            }
            submit.disabled = true;
            message.hidden = true;

            var properties = self.payload(result, product);
            properties.quiz_completed_at = new Date().toISOString();

            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(config.klaviyoKey), {
              method: 'POST',
              headers: { 'content-type': 'application/vnd.api+json', revision: '2026-07-15' },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: 'Start Here Quiz',
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: { email: email, properties: properties }
                      }
                    }
                  },
                  relationships: {
                    list: { data: { type: 'list', id: config.klaviyoListId } }
                  }
                }
              })
            }).then(function (response) {
              if (!response.ok) throw new Error('Subscription failed');
              row.hidden = true;
              message.textContent = "Thanks. You're on the list.";
              message.hidden = false;
              publish('start_here_quiz_email_captured', self.payload(result, product));
            }).catch(function () {
              submit.disabled = false;
              message.textContent = "That didn't go through. Please try again.";
              message.hidden = false;
            });
          }
        }, [
          el('label', { class: 'shq__email-heading', for: inputId, text: config.emailHeading || 'Get tips for your pick' }),
          row,
          config.emailConsent ? el('p', { class: 'shq__email-consent', text: config.emailConsent }) : null,
          message
        ]);

        return form;
      }

      renderLineup() {
        var self = this;
        var target = this.querySelector('[data-shq-lineup]');
        if (!target || !this.config.showLineup) return;

        function productLink(handle, text) {
          return el('li', {}, [el('a', { class: 'shq__link', href: self.productUrl(handle), text: text })]);
        }

        var cards = ORDER.map(function (key) {
          var m = LINEUP[key];
          var links = [];
          if (m.classic) {
            links.push(productLink(m.classic.alcohol_free, m.isSet ? 'Synergistic 4 Set, alcohol-free' : 'Classic tincture, alcohol-free'));
            links.push(productLink(m.classic.alcohol, m.isSet ? 'Synergistic 4 Set, traditional alcohol extract' : 'Classic tincture, traditional alcohol extract'));
          }
          if (m.gnar) links.push(productLink(m.gnar, m.isSet ? 'Gnar Tar 4-Set' : 'Gnar Tar concentrate'));

          return el('li', { class: 'shq__card' }, [
            el('div', {}, [
              el('h3', { class: 'h3', text: m.name }),
              el('p', { class: 'shq__card-goal', text: m.isSet ? 'Four mushrooms together' : m.goal })
            ]),
            el('p', {
              text: m.isSet
                ? 'The classic set has ' + m.classicContents + '. The Gnar Tar set has ' + m.gnarContents + '.'
                : m.supports
            }),
            el('ul', { class: 'shq__card-links', role: 'list' }, links)
          ]);
        });

        target.replaceChildren(
          el('h2', { class: 'shq__lineup-heading h2', text: this.config.lineupHeading || 'The lineup at a glance' }),
          el('p', { class: 'shq__lineup-lede', text: 'Five mushrooms, two formats. Here is everything in one place.' }),
          el('div', { class: 'shq__formats' }, ['classic', 'gnar'].map(function (key) {
            return el('div', { class: 'shq__format' }, [
              el('h3', { class: 'h3', text: FORMATS[key].name }),
              el('p', { text: FORMATS[key].blurb })
            ]);
          })),
          el('ul', { class: 'shq__cards', role: 'list' }, cards)
        );
      }
    }

    customElements.define('start-here-quiz', StartHereQuiz);

    /* Exposed for testing and debugging only. */
    window.StartHereQuiz = {
      LINEUP: LINEUP,
      ORDER: ORDER,
      POWDER_HANDLE: POWDER_HANDLE,
      nextStep: nextStep,
      resolve: resolve,
      whyLines: whyLines,
      monthlyPlan: monthlyPlan,
      defaultVariant: defaultVariant,
      sizeParts: sizeParts
    };
  })();

  } catch(e) { console.error(e); }
})();
})();
